import { render, staticRenderFns } from "./Preloader.vue?vue&type=template&id=214297dc&scoped=true&"
var script = {}
import style0 from "./Preloader.vue?vue&type=style&index=0&id=214297dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214297dc",
  null
  
)

export default component.exports